import Bugsnag from '@bugsnag/js';

export function bugsnagDiagnosticData(event) {
  const { app: { releaseStage } = {} } = event || {};
  if (
    (releaseStage || '').includes('nightly') ||
    process.env.NODE_ENV !== 'production'
  ) {
    return false;
  }
  let userId;
  let userName;
  let userEmail;
  let orgId;
  let currentOrgName;
  try {
    const { id, firstName, lastName, loginName } = JSON.parse(
      window.localStorage.getItem('user'),
    );
    orgId = window.localStorage.getItem('orgID');
    userId = id;
    userName = `${firstName} ${lastName}`;
    userEmail = loginName;
    currentOrgName = window.localStorage.getItem('currentOrgName');
  } catch (error) {
    userId = undefined;
    userName = undefined;
    userEmail = undefined;
    orgId = undefined;
    currentOrgName = undefined;
  }
  event.addMetadata('org', {
    name: currentOrgName,
    id: orgId,
  });
  event.setUser(userId, userEmail, userName);
}

export function notifyHandledException(error) {
  Bugsnag.notify(new Error(error), function(event) {
    bugsnagDiagnosticData(event);
  });
}
